/* eslint import/prefer-default-export: 0 */
import * as t from './action_types';

export const startLoadingProperties = () => ({
  type: t.DASHBOARD_START_LOADING_PROPERTIES,
});

export const stopLoadingProperties = () => ({
  type: t.DASHBOARD_STOP_LOADING_PROPERTIES,
});

export const startLoadingMoreProperties = () => ({
  type: t.DASHBOARD_START_LOADING_MORE_PROPERTIES,
});

export const stopLoadingMoreProperties = () => ({
  type: t.DASHBOARD_STOP_LOADING_MORE_PROPERTIES,
});

export const setPropertiesError = () => ({
  type: t.DASHBOARD_SET_PROPERTIES_ERROR,
});

export const setDashboardVersion = version => ({
  type: t.DASHBOARD_SET_VERSION,
  payload: version,
});

export const setDashboardVisibility = version => ({
  type: t.DASHBOARD_SET_SWITCH_VISIBILITY,
  payload: version,
});

export const changeDateActivity = dateActivity => ({
  type: t.DASHBOARD_CHANGE_DATE_ACTIVITY,
  payload: dateActivity,
});

export const changeOrder = (orderBy, orderValue) => ({
  type: t.DASHBOARD_CHANGE_ORDER,
  payload: {
    orderBy,
    orderValue,
  },
});

export const resetDashboardOptions = () => ({
  type: t.DASHBOARD_RESET_DASHBOARD_OPTIONS,
});

export const startLoadingMapPeople = () => ({
  type: t.MAP_DASHBOARD_START_LOADING_PEOPLE,
});

export const stopLoadingMapPeople = () => ({
  type: t.MAP_DASHBOARD_STOP_LOADING_PEOPLE,
});

export const startLoadingMapProperties = () => ({
  type: t.MAP_DASHBOARD_START_LOADING_PROPERTIES,
});

export const stopLoadingMapProperties = () => ({
  type: t.MAP_DASHBOARD_STOP_LOADING_PROPERTIES,
});
